import React from 'react'
import { Col } from 'react-bootstrap'
import FeatureList from '../../UpgradePayModal/components/FeatureList'
import styles from '../PaymentModal.module.css'
import { PLANS } from '../../../constants/plans'
import { UPGRADE, DOWNGRADE } from '../../UpgradePayModal/UpgradePayModal'

const getPlanColorClass = (planId) => {
  if (planId === PLANS.TINY.id) return 'text-blue'
  if (planId === PLANS.PRO.id) return 'text-purple'
  if (planId === PLANS.PRO_U.id) return 'text-warning'
  if (planId === PLANS.PRO_MAX.id) return 'text-dark'
  return 'text-light-purple'
}

const PlanFeatures = ({ plan, onClose, handleComparePlans, stage = null, list = [], currentPlan = null }) => {
  const isDowngrade = stage === DOWNGRADE
  const isUpgrade = stage === UPGRADE
  const isCurrentPlan = currentPlan && plan.id === currentPlan.id
  const planColorClass = getPlanColorClass(plan.id)

  const calculateHeight = () => {
    if (!isDowngrade) return {}
    const baseHeight = 200
    const itemHeight = 40
    const calculatedHeight = baseHeight + list.length * itemHeight
    const minHeight = Math.max(600, calculatedHeight)
    return {
      minHeight: `${minHeight}px`,
      maxHeight: '90vh',
      overflowY: 'auto'
    }
  }

  return (
    <Col
      xs={12}
      lg={5}
      className={`bg-light-grey p-4 ${styles.featureContainer} order-lg-0 order-first`}
      style={calculateHeight()}
    >
      <div className="d-block d-md-none">
        <img alt="delete" onClick={onClose} className="link float-right" src="/delete.png" height="20" />
      </div>
      <h2 className="mb-2 color-purple-2 font-22 ms-3 mt-2">
        {isCurrentPlan ? (
          <>
            <div className="text-dark-blue font-20 text-700">Your current plan</div>
            <div className={`${planColorClass} font-48 text-700 line-height-100 mt-2`}>{plan.label}</div>
          </>
        ) : isUpgrade && currentPlan ? (
          <>
            <div className="text-dark-blue font-20 text-700">
              Upgrade from <span className="text-dark-blue">{currentPlan.label}</span> to{' '}
            </div>
            <div className={`${planColorClass} font-48 text-700 line-height-100 mt-2`}>{plan.label}</div>
          </>
        ) : isDowngrade && currentPlan ? (
          <>
            <div className="text-dark-blue font-20 text-700">
              Downgrading from <span className="text-dark-blue">{currentPlan.label}</span> to{' '}
            </div>
            <div className={`${planColorClass} font-48 text-700 line-height-100 mt-2`}>{plan.label}</div>
          </>
        ) : (
          <>
            <div className="text-dark-blue font-20 text-700">Upgrade to </div>
            <div className={`${planColorClass} font-48 text-700 line-height-100 mt-2`}>{plan.label}</div>
          </>
        )}
        <div className={`${planColorClass} font-14 text-500 line-height-120 mt-2`}>Tiiny Host Subscription</div>
        {isDowngrade && currentPlan && (
          <div className="text-dark-blue font-16 text-500 mt-2">
            <b>You will lose access to:</b>
          </div>
        )}
      </h2>
      <FeatureList planId={plan.id} stage={stage} list={list} handleComparePlans={handleComparePlans} />
      <div className={`${styles.toc} d-none d-lg-block`}>
        By using our service you accept our{' '}
        <a href="https://tiiny.host/termsofservice.html" target="_blank" rel="noopener noreferrer">
          <u>terms & conditions</u>
        </a>{' '}
        &{' '}
        <a href="https://tiiny.host/privacypolicy.html" target="_blank" rel="noopener noreferrer">
          <u>privacy policy</u>
        </a>
      </div>
    </Col>
  )
}

export default PlanFeatures
